import { message } from "antd";
import { observable, action, flow } from "mobx";
import { registerHandler } from "services/api";
import { getCustomSites } from "services/customSites";

class CustomSitesStore {
	constructor() {
		this.ui = this.initUI();
		this.ui.loadingCustomSites = true;
	}

	initUI = () => {
		const ui = {
			loadingCustomSites: false,
			importingCustomSites: false,
			deletingCustomSites: false,
			verifyingCustomSites: false
		}
		return observable.object(ui);
	}

	@observable
	verifierStatus = "NEW";

	@observable
	sites = [];

	modules = {};

	loadCustomSites = flow(function*() {
		this.ui = this.initUI();
		this.ui.loadingCustomSites = true;
		let response = yield getCustomSites();
		if (response == null) {
			message.error("Failed to load custom sites. Unknown error", 5);
			return;
		}		
		if (response.error) {
			message.error(response.error, 5);
			return;
		}
		this.verifierStatus = response.verifierStatus;
		this.sites = observable.array(response.sites);
		this.modules = response.modules;
		this.ui.loadingCustomSites = false;				
	});

}

export default CustomSitesStore;